export default __webpack_public_path__ + "static/media/instagram.91fa9d4c.png";